import React, { Component } from "react";
import { POST, loading, profile, alert, t } from "../../components/CustomComponent.js";
import Language from "../../components/Language.js";
import LOGO from "../../assets/images/logo.png";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import { clearStorageKeepLang } from "../../utils/backendMessage";

// ไฟล์ติดตั้งแอปช่างวางไว้ที่ public/apk/application.apk — เสิร์ฟตรงจาก static server
// ไม่ผ่าน webpack (ไฟล์ ~110MB) build จึงไม่ช้าและอัปเดตไฟล์ใหม่ได้โดยไม่ต้อง build ใหม่
const APK_NAME = "application.apk";
const APK_URL = `${process.env.PUBLIC_URL || ""}/apk/${APK_NAME}`;

export default class MobileAppDownload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: "CMMS Service Co., Ltd.",
      file_size: "",
      apk_ready: true,
    };
  }

  componentDidMount() {
    loading(false);
    this.CheckApk();
  }

  // เช็คว่ามีไฟล์จริงไหม + อ่านขนาดจาก header (ไฟล์อยู่นอก bundle จึงฝังขนาดตอน build ไม่ได้)
  // dev server/SPA fallback จะตอบ index.html เป็น 200 ถ้าไม่มีไฟล์ จึงต้องเช็ค content-type ด้วย
  CheckApk = async () => {
    try {
      const res = await fetch(APK_URL, { method: "HEAD" });
      const contentType = res.headers.get("content-type") || "";
      if (!res.ok || contentType.includes("text/html")) {
        this.setState({ apk_ready: false });
        return;
      }
      const size = Number(res.headers.get("content-length"));
      if (size > 0) this.setState({ file_size: `${(size / 1024 / 1024).toFixed(1)} MB` });
    } catch (e) {
      // เช็คไม่ได้ (เช่นโดน CORS/proxy) ปล่อยให้ปุ่มยังกดได้ ไม่บล็อกผู้ใช้
    }
  };

  Download = () => {
    if (!this.state.apk_ready) {
      alert("", "warning", t("warning"), t("mobile_app_not_found"));
      return;
    }
    const link = document.createElement("a");
    link.href = APK_URL;
    link.download = APK_NAME;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  Logout = async () => {
    if (await alert("", "warning", t("confirm"), t("logout_ask"), "Logout", "cancel")) {
      loading(true);
      let result = await POST("auth/logout");
      if (result?.status) {
        clearStorageKeepLang();
        window.location.href = "/";
      }
      loading(false);
    }
  };

  render() {
    const { companyName, file_size, apk_ready } = this.state;

    return (
      <div
        className="min-vh-100 d-flex flex-column text-white font-sans"
        style={{ background: "linear-gradient(180deg, #1461bd 0%, #2985f2 100%)" }}
      >
        {/* Top Bar - Company */}
        <div className="w-100 d-flex justify-content-between align-items-center px-4 py-2" style={{ backgroundColor: "rgba(0,0,0,0.1)" }}>
          <div className="d-flex align-items-center" style={{ fontSize: "0.85rem" }}>
            <div className="me-2 rounded bg-white-light p-1 px-2 d-flex align-items-center justify-content-center">
              <span className="icon">{"\uf1ad"}</span>
            </div>
            <div>
              <div className="text-white-50" style={{ fontSize: "0.75rem" }}>
                {t("current_company")}
              </div>
              <div className="fw-bold">{companyName}</div>
            </div>
          </div>
          <div className="d-none d-xl-flex align-items-center">
            {/* ช่างเทคนิคเข้าได้เฉพาะพอร์ทัลมือถือ จึงไม่ต้องมีปุ่มกลับไปหน้าเลือกพอร์ทัล */}
            {profile?.user_type !== "technician" && (
              <button className="btn btn-sm text-white border-0 shadow-none" onClick={() => (window.location.href = "/portal")}>
                <span className="icon me-2">{"\uf060"}</span> {t("back_to_portal")}
              </button>
            )}
            <div className="hpx-40 mx-3" style={{ width: 1, backgroundColor: "var(--bs-gray-2)" }} />
            <div className="d-none d-xl-flex align-items-center text-start user-badge px-2 py-1 rounded-lg">
              <span className="user-avatar me-2 wpx-32 hpx-32 d-flex align-items-center justify-content-center" style={{ fontSize: "0.75rem" }}>
                {profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
              </span>
              <div className="pe-2">
                <div className="text-14 fw-semibold text-dark">{profile?.full_name || "Username"}</div>
                <div className="text-12 text-secondary" style={{ marginTop: -2 }}>
                  {profile?.role?.name || profile?.user_type?.replaceAll("_", " ") || "User"}
                </div>
              </div>
              <button className="btn btn-sm border-0 p-2 text-dark" style={{ opacity: 0.7 }} onClick={() => this.Logout()} title="Logout">
                <span className="icon">{"\uf08b"}</span>
              </button>
            </div>
          </div>
        </div>

        {/* Main Header */}
        <div className="container-fluid px-4 py-3 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <div className="bg-white rounded p-1 me-3 d-flex align-items-center justify-content-center" style={{ width: "45px", height: "45px" }}>
              <img src={LOGO} alt="logo" className="img-fluid" style={{ maxHeight: "100%" }} />
            </div>
            <div>
              <h4 className="mb-0 fw-bold">CMMS</h4>
              <small className="d-none d-md-block">Computerized Maintenance Management System</small>
            </div>
          </div>
          <Language />
        </div>

        {/* Download Card */}
        <div className="container my-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-9 col-lg-7">
              <div className="card border-0 rounded-4 shadow-lg p-4 p-md-5 text-center">
                <div
                  className="bg-warning text-light rounded-4 mx-auto d-flex align-items-center justify-content-center mb-4"
                  style={{ width: "90px", height: "90px" }}
                >
                  <span className="icon text-24">{"\uf3ce"}</span>
                </div>

                <h4 className="fw-bold text-dark mb-2">{t("mobile_app_download")}</h4>
                <p className="text-muted mb-4">{t("mobile_app_download_sub")}</p>

                {/* File info */}
                <div className="bg-light rounded-3 p-3 text-start mb-4">
                  <div className="d-flex justify-content-between align-items-center text-14">
                    <span className="text-muted">{t("mobile_app_file")}</span>
                    <span className="fw-bold text-dark text-break ms-3">{APK_NAME}</span>
                  </div>
                  {file_size ? (
                    <div className="d-flex justify-content-between align-items-center text-14 mt-2">
                      <span className="text-muted">{t("mobile_app_size")}</span>
                      <span className="fw-bold text-dark">{file_size}</span>
                    </div>
                  ) : null}
                  <div className="d-flex justify-content-between align-items-center text-14 mt-2">
                    <span className="text-muted">Version</span>
                    <span className="fw-bold text-dark">{global.version}</span>
                  </div>
                </div>

                <button
                  className="btn btn-primary btn-lg w-100 rounded-3 fw-bold shadow-sm d-flex align-items-center justify-content-center"
                  disabled={!apk_ready}
                  onClick={this.Download}
                >
                  <span className="icon me-2">{"\uf019"}</span> {t("download_apk")}
                </button>

                {!apk_ready ? <div className="text-danger text-14 mt-3">{t("mobile_app_not_found")}</div> : null}

                {/* Install steps */}
                <div className="text-start mt-5">
                  <h6 className="fw-bold text-dark mb-3 d-flex align-items-center">
                    <span className="icon text-primary me-2">{"\uf05a"}</span> {t("mobile_app_install_title")}
                  </h6>
                  <ol className="text-muted text-14 ps-3 mb-3">
                    <li className="mb-2">{t("mobile_app_install_1")}</li>
                    <li className="mb-2">{t("mobile_app_install_2")}</li>
                    <li className="mb-2">{t("mobile_app_install_3")}</li>
                  </ol>
                  <div className="bg-light border-start border-4 border-warning rounded-2 p-3 text-muted text-12">
                    {t("mobile_app_ios_note")}
                  </div>
                </div>
              </div>

              {profile?.user_type !== "technician" && (
                <div className="text-center mt-4">
                  <button className="btn btn-link text-white text-decoration-none fw-bold" onClick={() => (window.location.href = "/portal")}>
                    <span className="icon me-2">{"\uf060"}</span> {t("back_to_portal")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center py-4 mt-auto">
          <small className="opacity-80">
            CMMS Version {global.version} - Multi-Company Edition
            <br />
            Computerized Maintenance Management System
          </small>
        </div>
      </div>
    );
  }
}
